import { useEffect, useState } from "react";
import { listCatalogPages } from "lib/catalogPages";

export function useCatalogPages() {
  const [pages, setPages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;
    listCatalogPages()
      .then((data) => {
        if (isMounted) setPages(data);
      })
      .catch((err) => {
        if (isMounted) setError(err.message || "Could not load the catalog.");
      })
      .finally(() => {
        if (isMounted) setIsLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return { pages, isLoading, error };
}
